module.exports = __webpack_public_path__ + "static/media/pootsy-pink-logo.a1ff9de4.png";